import type { TpStripeSubscription } from '@features/Stripe/types';

export const getPlanRenderProps = ({
  plan,
  variant,
  wasTried,
  isCardSelected,
  onSelectPlan,
  handlePlanSelect,
  getPlanDisabled,
  inputIdPrefix,
}: {
  plan: TpStripeSubscription;
  variant: string;
  wasTried: boolean;
  isCardSelected: boolean;
  onSelectPlan: (id: string) => void;
  handlePlanSelect: () => void;
  getPlanDisabled: boolean;
  inputIdPrefix: string | undefined;
}) => ({
  plan,
  variant,
  wasTried,
  isCardSelected,
  onSelectPlan,
  handlePlanSelect,
  getPlanDisabled,
  inputIdPrefix,
});
